import React from 'react'
import '../css/Attribute.css'
export default function Attribute() {
  return (
    <div className='attribution'>
        Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noreferrer">Frontend Mentor</a>.
        <br /> 
        Coded by <a href="https://github.com/RahulSahOfficial" target='_blank' rel="noreferrer">Developer Sah</a>.
    </div>
  )
}
